import {asset} from 'imba';
import url from './memoji.png';
export default asset({
	url: url,
	type: 'image',
	width: 800,
	height: 800,
	toString: function(){ return this.url;}
})